/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

/**
 * Model `EntityCommentTypeModel`.
 */
@endpoint('deliverySurveyEntityComment/type')
export default class EntityCommentTypeModel extends BaseModel {
  /**
   * Properties.
   */
  code: string;

  level: string;

  name: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<EntityCommentTypeModel>) {
    super(data);
  }
}
